import React from 'react';

import {makeStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { InlineChat } from '../InlineChat/InlineChat';
import {useLocation} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    title: {
        marginRight: theme.spacing(4),
    },
    grow: {
        flexGrow: 1
    },
    toolbar: {
        columnGap: '8px'
    }
}))



export const Header = ({children}) => {
    const classes = useStyles()
    let location = useLocation();

    return <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <CssBaseline/>
        <Toolbar className={classes.toolbar}>
            <Typography
                variant="h6"
                className={classes.title}>
                Мастер актов
            </Typography>
            {location.pathname !== '/login' ? <InlineChat/> : <></> }
            <div className={classes.grow}/>
            {children}
        </Toolbar>
    </AppBar>
}